import type { ObjectFieldTemplateProps } from '@rjsf/utils';
import Markdown from 'react-markdown';

type Props = ObjectFieldTemplateProps & {
  mode: 'reader' | 'writer';
};

const ObjectFieldTemplateImpl = ({
  mode,
  title,
  description,
  properties
}: Props) => (
  <>
    {(title || description) && (
      <div className="mb-3 flex flex-col gap-1">
        {mode === 'writer' && title && (
          <p className="font-semibold text-base">{title}</p>
        )}
        {description && (
          <div className="mb-2.5 text-muted-foreground text-xs">
            <Markdown>{description}</Markdown>
          </div>
        )}
      </div>
    )}
    {properties.map(property => property.content)}
  </>
);

export const ObjectFieldTemplateWriter = (props: Omit<Props, 'mode'>) => (
  <ObjectFieldTemplateImpl {...props} mode="writer" />
);

export const ObjectFieldTemplateReader = (props: Omit<Props, 'mode'>) => (
  <ObjectFieldTemplateImpl {...props} mode="reader" />
);
